module.exports = __webpack_public_path__ + "assets/f861091eff21ea1716f186c98f96c055.mp3";